import { lazy } from 'react';
import { useParams } from 'react-router';
import { useBundleSurrenderSettings } from 'src/apis/surrender-service/use-bundle-surrender-settings';
import { useEligibleSurrenderInquiryDeals } from 'src/apis/surrender-service/use-eligible-surrender-inquiry-deals';
import { useNetworkPointSurrenderSettings } from 'src/apis/surrender-service/use-network-point-surrender-settings';
import { useSurrenderRoot } from 'src/apis/surrender-service/use-surrender-root';
import { PageSpinner } from 'src/components/spinner-container';
import { Forbidden } from 'src/utils/errors';

const UnbundledPage = lazy(() => import('./page-unbundled'));
const BundledPage = lazy(() => import('./page-bundled'));

export const CreateSurrenderRequest = () => {
  const surrenderRoot = useSurrenderRoot();
  const { networkPointId } = useParams<{ networkPointId?: string }>();
  const surrenderSettings = useNetworkPointSurrenderSettings({
    surrenderRoot,
    networkPointId,
  });
  const eligibleDeals = useEligibleSurrenderInquiryDeals({
    surrenderRoot,
    params: networkPointId ? { networkPointId } : undefined,
  });

  if (!surrenderRoot.response) return <PageSpinner />;
  if (
    !networkPointId ||
    !surrenderRoot.response.data._links.isSurrenderForAllEnabled
  )
    throw new Forbidden();
  if (!surrenderSettings?.response || !eligibleDeals?.response)
    return <PageSpinner />;

  return (
    <UnbundledPage
      networkPointId={networkPointId}
      surrenderRoot={surrenderRoot}
      surrenderSettings={surrenderSettings}
      eligibleDeals={eligibleDeals}
    />
  );
};

export const CreateBundleSurrenderRequest = () => {
  const surrenderRoot = useSurrenderRoot();
  const { bundleId } = useParams<{ bundleId?: string }>();
  const surrenderSettings = useBundleSurrenderSettings({
    surrenderRoot,
    bundleId,
  });
  const eligibleDeals = useEligibleSurrenderInquiryDeals({
    surrenderRoot,
    params: bundleId ? { bundleId } : undefined,
  });

  if (!surrenderRoot.response) return <PageSpinner />;
  if (!bundleId || !surrenderRoot.response.data._links.isSurrenderForAllEnabled)
    throw new Forbidden();
  if (!surrenderSettings?.response || !eligibleDeals?.response)
    return <PageSpinner />;

  return (
    <BundledPage
      bundleId={bundleId}
      surrenderRoot={surrenderRoot}
      surrenderSettings={surrenderSettings}
      eligibleDeals={eligibleDeals}
    />
  );
};
